import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Typography } from "antd";
import React from "react";
import { useNavigate } from "react-router";

const Shortcut = ({ ...props }) => {
  const history = useNavigate();

  const handleShortcut = (component) => {
    history(component);
  };

  return (
    <Card
      hoverable
      className="erp-shortcut"
      cover={
        <div style={{ textAlign: "center", padding: "none" }}>
          <FontAwesomeIcon className="erp-shortcut-icon" icon={["fas", props.icon]} size="6x" />
        </div>
      }
      onClick={() => handleShortcut(props.route)}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key == 'Enter') {
          e.preventDefault();
          handleShortcut(props.route)
        }
      }}
      role="button"
    >
      <div style={{ textAlign: "center" }}>
        <Typography.Text>{props.name}</Typography.Text>
      </div>
    </Card>
  );
};

export default Shortcut;
